import React, {Component} from 'react';
import {Modal, Button } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import PropTypes from "prop-types";
import AdminUserDetail from "../AdminUserDetail";



class AdminUserDetailModal extends Component {
    static contextTypes = { api: PropTypes.object };

    render(){
        return (
            <Modal
                show={true}
                onHide={this.props.onHide}
                className='PersonDetailModal'
            >
                <Modal.Header closeButton >
                    <Modal.Title>Detalles del usuario</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <AdminUserDetail
                        person={this.props.person}
                        canEdit={this.props.canEdit}
                    />


                </Modal.Body>

                <Modal.Footer>
                    <Button bsStyle='danger' onClick={this.props.onHide}>Cerrar</Button>
                </Modal.Footer>

            </Modal>
        );
    }
}

export default AdminUserDetailModal;



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/AdminUsers/components/AdminUserDetailModal/index.js